<div class="container single-view" id="add-product-type">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/product-types/"  class="inline-flex items-center text-base link link-icon left-arrow">{{
        'PRODUCT_TYPES.BTN_BACK_TO_PRODUCT_TYPE' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-producttype-title" class="section-title">{{ 'PRODUCT_TYPE_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-producttype-subtitle" class="section-subtitle mt-1 text-base">{{ 'PRODUCT_TYPE_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form data-testid="add-producttype-form" class="mt-0" [formGroup]="productTypeForm">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-producttype-details-title" class="border-b pb-3">{{ 'PRODUCT_TYPE_CREATE.PRODUCT_TYPE_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-producttype-field-name" class="block text-sm" for="name">{{ 'PRODUCT_TYPE_CREATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-producttype-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                  @if (productTypeForm.get('name')?.invalid && productTypeForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-producttype-field-code" class="block text-sm" for="code">{{ 'PRODUCT_TYPE_CREATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-producttype-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                  @if (productTypeForm.get('code')?.invalid && productTypeForm.get('code')?.touched) {
                    <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-producttype-field-url" class="block text-sm" for="imageUrl">{{ 'PRODUCT_TYPE_CREATE.DEFAULT_URL' | translate }} </label>
                  <input data-testid="add-producttype-url-input" type="text" id="imageUrl" formControlName="imageUrl" autocomplete="off">
                </div>
                <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <span data-testid="add-producttype-field-hasParent" class="block text-sm mb-3" for="hasParentProductType">{{ 'PRODUCT_TYPE_CREATE.HAS_PARENT' | translate }}</span>
                  <label data-testid="add-producttype-has-parent-yes-label" class="inline-flex mr-6">
                    <p-radioButton data-testid="add-producttype-has-parent-yes" name="hasParentProductType" value="true" formControlName="hasParentProductType" inputId="yes" />
                    <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                  </label>
                  <label data-testid="add-producttype-has-parent-no-label" class="inline-flex mr-2">
                    <p-radioButton data-testid="add-producttype-has-parent-no" name="hasParentProductType" value="false" formControlName="hasParentProductType" inputId="no" />
                    <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                  </label>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3"
                  [ngClass]="{'disabled': productTypeForm.get('hasParentProductType')?.value == 'false'}">
                  <label class="block text-sm" for="productTypeId">{{ 'PRODUCT_TYPE_CREATE.PARENT_PRODUCT_TYPE' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="parentproducttype"
                    [placeholder]="'PRODUCT_TYPE_CREATE.SELECT_PARENT_PLACEHOLDER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="comboData.rowsPerPageOption || 5"
                    [totalCount]="comboData.totalRecords"
                    [totalPages]="getComboTotalPages()"
                    [options]="comboData.list"
                    formControlName="productTypeId"
                    (onLazyLoad)="onLazyLoadComboData($event)">
                  </app-custom-dropdown>
                  @if (productTypeForm.errors?.['requiredproductType'] && isProductTypeRequired()) {
                    <small data-testid="parent-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-producttype-create-producttype-button" class="btn primary-btn" [disabled]="productTypeForm.invalid"
                      (click)="submitForm()">{{
                    'PRODUCT_TYPE_CREATE.BTN_CREATE_PRODUCT_TYPE' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
